"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Property = exports.MediaType = exports.ArticleType = void 0;
// Categories that articles may fall under
var ArticleType;
(function (ArticleType) {
    ArticleType["CREDIT_SCORE_OPTIMIZATION"] = "CREDIT_SCORE_OPTIMIZATION";
    ArticleType["FINANCIAL_HEALTH"] = "FINANCIAL_HEALTH";
    ArticleType["BUDGETING"] = "BUDGETING";
})(ArticleType || (exports.ArticleType = ArticleType = {}));
var MediaType;
(function (MediaType) {
    MediaType["ARTICLE"] = "ARTICLE";
    MediaType["VIDEO"] = "VIDEO";
})(MediaType || (exports.MediaType = MediaType = {}));
// Represents the Aven vertical that the media pertains to
var Property;
(function (Property) {
    Property["AVEN_ADVISOR"] = "AVEN_ADVISOR";
})(Property || (exports.Property = Property = {}));
